import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router-dom';
import axios from 'api/request';
import { useMutation } from 'react-query';
// import { styled } from '@mui/material/styles';
import { Box, Typography, Divider, Dialog, DialogTitle, DialogContent, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';
// import CropFreeOutlinedIcon from '@mui/icons-material/CropFreeOutlined';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { endPoints } from 'api/endpoints';
import InfoTooltip from 'pages/reference-implementation/components/info-tooltip';
import { catalogServiceCardstyle, CustomTagButton } from 'pages/landing/style';
import { allowedServices, isDiscontinuedService, isCMPAdmin } from 'utils';
import { canAccessCatalog } from 'utils/announcementRestrictions';
import { getDiscontinuedButtonLabel } from 'utils/discontinuedCatalogs';
import {
    RICatalogCode001,
    RICatalogCode001A,
    RICatalogCode003O,
    RICatalogCode003AWS,
    RICatalogCode003,
    RICatalogCode003A,
    RICatalogCode005,
    RICatalogCode004O,
    RICatalogCode002O,
} from 'pages/reference-implementation/utils/RICatalogCode';

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//     '& .MuiDialogContent-root': {
//         padding: theme.spacing(2),
//     },
//     '& .MuiDialogActions-root': {
//         padding: theme.spacing(1),
//     },
//     '& .MuiPaper-root': {
//         overflow: 'visible',
//         // maxWidth: '70%',
//         // height: '600px',
//     },
// }));

function BootstrapDialogTitle(props) {
    const { children, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.element,
};

BootstrapDialogTitle.defaultProps = {
    children: <></>,
};

export default function CustomizedDialogs({ isOpen, setOpen, title, provisioningPath, description, helpUrl, tags, rid }) {
    const history = useHistory();
    const theme = useTheme();
    const isXlSize = useMediaQuery(theme.breakpoints.up('xl'));
    const [isFullScreen, setFullScreen] = React.useState(false);
    const [imgUrl, setImgUrl] = React.useState(undefined);
    const archDiagramApi = useMutation((payload) => axios.get(endPoints.riServices.Jwt.architecture?.replace('{rid}', payload?.rid)));
    const iff = (condition, then, otherwise) => (condition ? then : otherwise);

    const getButtonLabel = () => {
        if (isDiscontinuedService(rid) && !isCMPAdmin()) {
            return getDiscontinuedButtonLabel(rid);
        }
        if (allowedServices(rid)) {
            return 'Start Provisioning';
        }
        return 'Coming Soon';
    };

    React.useEffect(() => {
        if (rid) {
            setImgUrl(undefined);
            // const fileFormat = selectedDoc?.blobRelativeLink?.split('.')?.slice(-1)[0] || null;
            // if (fileFormat === 'pdf') {
            archDiagramApi.mutate({
                rid,
            });
            // }
        }
    }, [rid]);

    React.useEffect(() => {
        // istanbul ignore if
        if (archDiagramApi?.isSuccess) {
            const blob = new Blob([archDiagramApi?.data], { type: 'image/jpeg' });
            const fileURL = URL.createObjectURL(blob);
            setImgUrl(fileURL);
        }
    }, [archDiagramApi?.isSuccess]);

    return (
        <Dialog
            fullScreen={isFullScreen}
            fullWidth={false}
            maxWidth="md"
            onClose={() => setOpen(false)}
            sx={{ ...(!isFullScreen && { '& .MuiPaper-root': { height: '100%', maxHeight: 'none', border: '10px solid #D7E5F8', backgroundColor: '#fff' } }) }}
            aria-labelledby="customized-dialog-title"
            open={isOpen}
        >
            <BootstrapDialogTitle id="customized-dialog-title">
                <Box display="flex" alignItems="center" flexDirection="row" alignContent="center">
                    <Typography sx={{ mr: 1, fontSize: 14, fontWeight: 900, mb: 1 }}> {title}</Typography>
                    {![
                        RICatalogCode001,
                        RICatalogCode001A,
                        RICatalogCode003O,
                        RICatalogCode003AWS,
                        RICatalogCode003,
                        RICatalogCode003A,
                        RICatalogCode004O,
                        RICatalogCode002O,
                        RICatalogCode005,
                    ].includes(rid) && (
                        <InfoTooltip
                            title={
                                <>
                                    <a href={helpUrl} target="_blank" rel="noreferrer">
                                        Click here for further details
                                    </a>
                                </>
                            }
                        />
                    )}
                    <Box display="flex" justifyContent="center" alignItems="center" marginLeft="auto">
                        <Btn
                            className="btn-disabled custom-btn"
                            variant={canAccessCatalog(rid) ? 'contained' : 'outlined'}
                            sx={{ ...style.primaryMediumButton, ml: 'auto', mr: 1 }}
                            disabled={!canAccessCatalog(rid)}
                            onClick={() => {
                                if (canAccessCatalog(rid)) {
                                    setOpen(false);
                                    history.push(provisioningPath);
                                }
                            }}
                            data-testid="provisioning-btn"
                            disableRipple
                        >
                            {getButtonLabel()}
                        </Btn>

                        <Box display="flex" justifyContent="center" alignItems="center" marginLeft="auto" gap={1}>
                            {isFullScreen && (
                                <CloseFullscreenIcon
                                    cursor="pointer"
                                    sx={{ width: '0.8em', height: '0.8em', '& :hover': { color: '#1976d2' } }}
                                    onClick={() => {
                                        setFullScreen(!isFullScreen);
                                    }}
                                />
                            )}

                            {!isFullScreen && (
                                <OpenInFullIcon
                                    cursor="pointer"
                                    sx={{ width: '0.8em', height: '0.8em', '& :hover': { color: '#1976d2' } }}
                                    onClick={() => {
                                        setFullScreen(!isFullScreen);
                                    }}
                                />
                            )}
                            <CloseIcon
                                cursor="pointer"
                                sx={{ width: '0.8em', height: '0.8em', '& :hover': { color: '#1976d2' } }}
                                onClick={() => {
                                    setOpen(false);
                                    setFullScreen(false);
                                }}
                            />
                        </Box>
                    </Box>
                </Box>
            </BootstrapDialogTitle>
            <Divider />
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', overflowY: 'scroll' }}>
                {(!imgUrl || archDiagramApi?.isLoading) && (
                    <Box
                        display="flex"
                        border="1px solid #c3c3c3"
                        alignItems="center"
                        justifyContent="center"
                        alignSelf="center"
                        height={isFullScreen ? '100%' : iff(isXlSize, '36em', '24em')}
                        width={isFullScreen ? '90%' : '90%'}
                    >
                        <CircularProgress color="inherit" size={16} sx={{ color: '#000000' }} />
                    </Box>
                )}
                {imgUrl && !archDiagramApi?.isLoading && (
                    <Box
                        display="flex"
                        border="1px solid #c3c3c3"
                        alignItems="center"
                        justifyContent="center"
                        alignSelf="center"
                        height={isFullScreen ? '160%' : iff(isXlSize, '36em', '24em')}
                        width={isFullScreen ? '100%' : '90%'}
                    >
                        <img src={imgUrl} alt="loading" height="100%" width="100%" />
                    </Box>
                )}
                {/* {!archImg && (
                    <Box
                        display="flex"
                        border="1px solid #c3c3c3"
                        alignItems="center"
                        justifyContent="center"
                        alignSelf="center"
                        height={isFullScreen ? '100%' : iff(isXlSize, '36em', '24em')}
                        width={isFullScreen ? '90%' : '90%'}
                    >
                        <CircularProgress color="inherit" size={16} sx={{ color: '#000000' }} />
                    </Box>
                )}
                {archImg && (
                    <Box
                        display="flex"
                        border="1px solid #c3c3c3"
                        alignItems="center"
                        justifyContent="center"
                        alignSelf="center"
                        height={isFullScreen ? '100%' : iff(isXlSize, '36em', '24em')}
                        width={isFullScreen ? '90%' : '90%'}
                    >
                        <img src={archImg} alt="loading" height="100%" width="100%" />
                    </Box>
                )} */}

                {/* <img
                    src="/static/images/RI/RI001-Architecture-Diagram.png"
                    alt="loading"
                    style={{ margin: 'auto', border: '1px solid #c3c3c3' }}
                    height={450}
                    width={780}
                /> */}

                <Typography sx={{ fontSize: 14, fontWeight: 900, mt: 2 }}>{`About ${title}`}</Typography>
                <Typography gutterBottom>{description}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 900, mt: 2 }}>Tags</Typography>
                <Box>
                    {tags?.length > 0 &&
                        tags?.map((item) => (
                            <CustomTagButton key={item} variant="contained" sx={catalogServiceCardstyle.tagButton} disableElevation disableRipple>
                                {item}
                            </CustomTagButton>
                        ))}
                </Box>
            </DialogContent>
        </Dialog>
    );
}

CustomizedDialogs.propTypes = {
    rid: PropTypes.string,
    title: PropTypes.string,
    provisioningPath: PropTypes.string,
    description: PropTypes.string,
    helpUrl: PropTypes.string,
    tags: PropTypes.any,
    isOpen: PropTypes.bool,
    setOpen: PropTypes.func,
    // archImg: PropTypes.string,
};

CustomizedDialogs.defaultProps = {
    rid: '',
    title: '',
    provisioningPath: '',
    description: '',
    helpUrl: '',
    tags: [],
    isOpen: false,
    setOpen: () => null,
    // archImg: '',
};
